import { SelectedRows } from '../../../datasetData/context/types'
import { Trans } from '@lingui/react/macro'
import { getTooltip } from './utils'

interface EditSelectRowsTooltipProps {
  numSelectedRows: number
  firstRowSelected: number
  lastRowSelected: number
  selectedRows: SelectedRows
}

export function EditSelectRowsTooltip({
  selectedRows,
  numSelectedRows,
  firstRowSelected,
  lastRowSelected,
}: EditSelectRowsTooltipProps) {
  const chunksOfSelectedRows: number[][] = [[firstRowSelected]]
  let chunkIndex = 0
  const rows = Object.keys(selectedRows)

  for (let index = 1; index < rows.length; index++) {
    const currentRow = Number(rows[index])
    const previousRow = Number(rows[index - 1])

    chunksOfSelectedRows[chunkIndex] = [...(chunksOfSelectedRows[chunkIndex] ?? []), currentRow]

    if (currentRow - previousRow !== 1) {
      chunkIndex = chunkIndex += 1
    }
  }

  const tooltipMessage = getTooltip(
    numSelectedRows,
    firstRowSelected,
    lastRowSelected,
    chunksOfSelectedRows,
  )

  return (
    <>
      <div data-testid="tooltip-message">{tooltipMessage}</div>
      <Trans>Max of 1,000 Rows</Trans>
    </>
  )
}
